import React from 'react';
import { Accordion, Button, Icon, Table, Select } from 'semantic-ui-react';
import PremiumTag from '../../../assets/images/premium-tag.svg';
import { Link } from 'react-router-dom';
import FollowButton from '../FollowButton';
import { Row, Col } from '../../common';
import EditCapacity from '../../company_page/EditCapacity';
import { commonActions, productActions } from '../../../actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { replaceSpaceInName, sortList, sortListByStringKey } from '../../../common/helperMethods';
import GuestUserLoginToast from '../../common/GuestUserLoginAlert';
import LoginButton from '../../common/LoginButton';

const sortOption = [
    { key: 'name', value: 'company_name', text: 'name' },
    { key: 'country', value: 'country', text: 'country' },
    { key: 'No. of contacts', value: 'contacts', text: 'contacts' }
]

const defaultValue = "";  // "country";

class SuppliersList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showSupplierLoader: false,
            sortBy: "",
            visibleSuppliers: 5,
            showLoginAlert: false,
            activeSupplier: null,
        }
    }

    getSortedSuppliersList = () => {
        let sortedList = [];
        const { sortBy } = this.state;
        const { suppliers } = this.props;
        const suppliersList = suppliers && suppliers.results;

        if (suppliersList) {
            if (sortBy === "premium") {
                sortedList = suppliersList.sort((a, b) => (b.premium - a.premium) ||
                    (a.company_name && b.company_name ? a.company_name.localeCompare(b.company_name) : -1));
            }
            else if (sortBy === "country" || sortBy === "company_name") {
                sortedList = sortListByStringKey(suppliersList, sortBy);
            }
            else {
                sortedList = sortList(suppliersList, sortBy, "desc");
            }
        }
        return sortedList;
    }

    handleMoreClick() {
        const { auth, suppliers, showLoginModal } = this.props;
        const supplierCount = suppliers && suppliers.count || 0;

        if (!auth) {
            // showLoginModal(true);
            this.ShowLogin(true);
        }
        else {
            this.setState({ showSupplierLoader: true });
            setTimeout(() => {
                this.setState({
                    visibleSuppliers: supplierCount,
                    showSupplierLoader: false
                })
            }, 1000);
        }
    }

    setSortBy = (e, { value }) => {
        this.setState({ sortBy: value })
    }

    ShowLogin = (flag) => {
        if (flag == true) {
            this.setState({ showLoginAlert: true })
        }
    }

    setStateLoginClose = () => {
        this.setState({ showLoginAlert: false })
    }

    expandSupplier = (e, titleProps) => {
        const { index } = titleProps;
        const { activeSupplier } = this.state;
        const newActive = activeSupplier === index ? null : index;
        this.setState({ activeSupplier: newActive });
    }

    render() {
        const { auth, suppliers, productId, productName, refresh_products } = this.props;
        if (!suppliers) return null;

        const { visibleSuppliers, activeSupplier } = this.state;
        const supplierList = suppliers && suppliers.results;
        const supplierCount = suppliers && suppliers.count || 0;
        const sortedSuppliersList = supplierList && this.getSortedSuppliersList().slice(0, visibleSuppliers);

        return (
            <React.Fragment>
                <div className="supplier-list">
                    <Table basic="very">
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan='4'>
                                    <div className="d-flex align-items-center">
                                        <div className="d-flex align-items-center">
                                            {/* <Checkbox className="mr-3" /> */}
                                            Sort By
                                        </div>
                                        <div className="filter-select">
                                            <Icon name="filter" />
                                            <Select defaultValue={defaultValue} options={sortOption} onChange={this.setSortBy} />
                                        </div>
                                    </div>
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan='1'>
                                </Table.HeaderCell>
                                {/* <Table.HeaderCell colSpan='2' className="text-right">
                                    <Button primary basic className="py-2 px-3">Request Quote</Button>
                                </Table.HeaderCell> */}
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {sortedSuppliersList.map(({ company_name, company_id, contacts, country, images, premium, logo, contactsDetails, current_capacity, future_capacity, current_unit, future_unit }) => {
                                const productForCapacity = {
                                    product_id: productId,
                                    product_name: productName,
                                    current_capacity: current_capacity,
                                    current_unit: current_unit,
                                    future_capacity: future_capacity,
                                    future_unit: future_unit,
                                };
                                const companyForCapacity = { id: company_id };
                                return (
                                    <Table.Row key={company_id}>
                                        <Table.Cell colSpan="5" className="p-0">
                                            <Accordion className="supplier-accordion rawmaterial-list" styled fluid>
                                                <Accordion.Title
                                                    active={activeSupplier === company_id}
                                                    index={company_id}
                                                    onClick={this.expandSupplier}
                                                >
                                                    <div className='supplier-row-inner'>
                                                        <div className="supplier-row-item supplier-row-image">
                                                            {logo ? <img className="logo-img" src={logo} alt="LOGO" />
                                                                : <div className="supplierdetails-circle">{company_name && company_name.substring(0, 1)}</div>}
                                                        </div>
                                                        <div className="supplier-row-item supplier-row-name">
                                                            <Link to={`/company/${replaceSpaceInName(company_name)}/${company_id}`}>
                                                                <p className="suppliername">{company_name}</p>
                                                                <div className="addresses">
                                                                    {country}
                                                                    {premium && <img style={{ width: 56, marginBottom: -3, marginLeft: 2 }} src={PremiumTag} alt="" />}
                                                                </div>
                                                            </Link>
                                                        </div>
                                                        <div className="supplier-row-item supplier-row-contacts">
                                                            <ul className="contactlist">
                                                                {
                                                                    contactsDetails && contactsDetails.length > 0 && contactsDetails.map((contact, idx) =>
                                                                        contact.image ? <li key={idx}><img src={contact.image} alt="" /></li> :
                                                                            contact.firstName != undefined && <li key={idx} className='init-circles'>{contact.firstName.substring(0, 1)}</li>
                                                                    )
                                                                }
                                                            </ul>
                                                            {contacts > 0 && <span className="text-muted contacts-count">{contacts} contacts</span>}
                                                        </div>
                                                        <div className="supplier-row-item supplier-row-follow" onClick={(e) => e.stopPropagation()}>
                                                            <FollowButton id={company_id} name={company_name} type="company" history={this.props.history} ShowLogin={this.ShowLogin} />
                                                        </div>
                                                        <div className="supplier-row-item supplier-row-edit" onClick={(e) => e.stopPropagation()}>
                                                            {auth && productId && <EditCapacity product={productForCapacity} company={companyForCapacity} auth={auth} refresh_products={refresh_products} />}
                                                        </div>
                                                        <div className="supplier-row-item supplier-row-dropdown">
                                                            <Icon className="mt-n1" name='dropdown' />
                                                        </div>
                                                    </div>

                                                </Accordion.Title>

                                                <Accordion.Content active={activeSupplier === company_id}>
                                                    <Row className='capacity-row'>
                                                        <Col xs="6">
                                                            {current_capacity != null && current_capacity !== '' && current_unit && (
                                                                <>
                                                                    <label>Current Capacity</label>
                                                                    <p>{current_capacity} {current_unit}</p>
                                                                </>
                                                            )}
                                                        </Col>
                                                        <Col xs="6">
                                                            {future_capacity != null && future_capacity !== '' && future_unit && (
                                                                <>
                                                                    <label>Future Capacity</label>
                                                                    <p>{future_capacity} {future_unit}</p>
                                                                </>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                    <Link to={`/company/${replaceSpaceInName(company_name)}/${company_id}`} className="text-primary">
                                                        View full company profile →
                                                    </Link>
                                                </Accordion.Content>
                                            </Accordion>
                                        </Table.Cell>
                                    </Table.Row>
                                );
                            })}
                            {
                                supplierCount > visibleSuppliers && (

                                    /*  <Button
                                         className="color-light-blue cursor-pointer load_more"
                                         onClick={this.handleMoreClick.bind(this)}
                                         loading={this.state.showSupplierLoader}
                                     > Load More
                                         {this.props.auth ?
                                             this.props.auth.isActive ? "See All"
                                                 :
                                                 "Upgrade to see the complete list"
                                             : "Load More"} 
                                     </Button> */
                                    <Table.Row>
                                        <Table.Cell colSpan="5" className="text-center">
                                            {
                                                auth ?
                                                    <Button className="color-light-blue w-100 text-center mt-2 cursor-pointer load_more" onClick={this.handleMoreClick.bind(this)} loading={this.state.showSupplierLoader} >
                                                        See All
                                                    </Button>
                                                    :
                                                    <LoginButton />
                                            }
                                        </Table.Cell>
                                    </Table.Row>
                                )
                            }
                        </Table.Body>
                    </Table>
                </div>
                <GuestUserLoginToast {...this.props} show={this.state.showLoginAlert} setStateLoginClose={() => this.setStateLoginClose()} />
            </React.Fragment >
        )
    }
}

function mapStateToProps({ singleProduct, auth, common }) {
    return { suppliers: singleProduct.suppliers, auth, common };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        ...bindActionCreators({ ...productActions, ...commonActions }, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SuppliersList);